import Api from "js/core/api";
import getLogger, { LogGroup } from "js/core/logger";

const logger = getLogger(LogGroup.ANALYTICS);

export const removePrefix = (obj, prefix) => {
    Object.keys(obj).forEach(key => {
        if (key.indexOf(prefix) === 0) {
            obj[key.slice(3)] = obj[key];
            delete obj[key];
        }
    });
};

export function getAuditProps(options, props) {
    const pg_props = { ...props };
    removePrefix(pg_props, "pg_");

    delete pg_props.email;
    delete pg_props.affected_user_id;
    delete pg_props.presentationId;
    delete pg_props.workspace_id;

    // Props an event sends to the product analytics providers but that must not be written here. The
    // audit table is durable and a workspace owner can export every row of it through /api/logs, so a
    // prop carrying a member's own words reaches someone with no access to the document it came from.
    for (const key of options.auditOmit ?? []) {
        delete pg_props[key];
    }
    pg_props.label = options.label;
    pg_props.value = options.value;

    return pg_props;
}

export async function logAuditEvent(options, props, user) {
    if (!options.audit || !user) return;

    const pg_props = getAuditProps(options, props);

    const columns = {
        category: options.category,
        action: options.action,
        affected_user_id: props.pg_affected_user_id,
        presentation_id: props.presentationId,
        workspace_id: props.workspace_id,
        props: JSON.stringify(pg_props),
        email: user.email,
    };

    Api.audit.post({
        namespace: "analytics",
        action: null,
        props: columns
    }).catch(err => {
        logger.error(err, "Api.audit.post() failed");
    });
}
